import React from 'react'

export default function NotAvailable() {
  return (
    <h1 className='not-available'>
        No Movies available for selected genre
    </h1>
  )
}
